import { forwardRef } from 'react';
import { StyledListItem, StyledListLink } from './styled';

const ListItem = forwardRef((props, ref) => {
  const { to } = props;

  if (to) {
    return <StyledListLink ref={ref} {...props} />;
  } else {
    return <StyledListItem ref={ref} {...props} />;
  }
});

export default ListItem;
